import React from "react";
import apiClient from "../../common/apiClient";
import "../card/card.scss";
import { Dialog } from "@mui/material";
import Button from "../button/Button";
import { CloseIcon } from "../../icons/svg";
import tickIcon from "../../images/tickIcon.png";
import { CloseNotification } from "../../components/notification/Notification";

const ClearMultiOrder = ({ openClear, handleCloseClear, showClear, removeProduct, setShowClear, formId, handleClearBack, clearOrderMessage }) => {
  const formID = formId;

  const handleClearShow = () => {
    PostClear();
    setShowClear(false);
  };

  const handleNavigation = () => {      
    setShowClear(false);
    handleClearBack(formId);
    handleCloseClear();
  };

  async function PostClear() {
    CloseNotification();
    await apiClient.post(`ClearOrder/${formID}?isMulti=true`,
      null
    );
  }

  return (
    <div className={`ClearOrder ${!showClear ? "submitWidth" : ""}`}>
      <Dialog
        onClose={handleCloseClear}
        aria-labelledby="customized-dialog-title"
        open={openClear ?? false}
        className={`ClearOrder ${!showClear ? "submitWidth" : ""}`}
      >
        {showClear ? (
          <>
            <div className="modalHeader">
              <h3 className="h3">Clear Order?</h3>
              <button onClick={handleCloseClear}>
                <CloseIcon />
              </button>
            </div>
            <div className="modalContent">
              <p>{clearOrderMessage}</p>
              <p>Would you like to clear the pending order and proceed with the current order?</p>
              <div style={{display: "flex", gap: "16px"}}>
                <Button
                  style={{width: "150px"}}
                  text="Yes, Clear Order"
                  type="button"
                  onClick={handleClearShow}
                />
                <Button
                  text="No"
                  type="button"
                  onClick={handleCloseClear}
                />
              </div>
            </div>
          </>
         ) : (
          <>
            <div className="clearModal">
              <div className="modalHeader">
                <button onClick={handleCloseClear}>
                  
                </button>
                </div>
              <div className="modalContent">
                <img
                  src={tickIcon}
                  width="71px"
                  height="66px"
                  alt="tick-icon"
                />
                <h3 className="h3">Cleared</h3>
                <p>
                  Your order form will clear successfully!
                </p>
                <Button
                text="Confirm"
                type="button"
                onClick={handleNavigation}
              />
              </div>
            </div>
          </>
        )}
      </Dialog>
    </div>
  );
};

export default ClearMultiOrder;